// extracted by mini-css-extract-plugin
export const root = "fc-image-module--root--2eNyU";
export const right = "fc-image-module--right--2Bp3G";